<template>
  <div id="app">
    <base-header ref="baseHeader" v-if="$route.path !== '/404'"/>
    <base-nav @clickIndex="handleClickIndex" />
    <transition :name="transitionName" mode="out-in">
      <router-view v-if="$route.meta.noCache" />
      <keep-alive v-else>
        <router-view/>
      </keep-alive>
    </transition>
    <privacy-modal :value.sync="isShowPrivacy" @submit="submitAgreePrivacyPolicy"></privacy-modal>
  </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue'
import BaseNav from '@/components/BaseNav.vue'
import PrivacyModal from "@/components/PrivacyModal";
import {getUserName, gioTracking} from '@/plugins/common'
import api from './api'
import {Dialog} from 'vant'
import {hideLoading, showAlert, showLoading} from "@/utils/tools";
import {setCookie} from "@/utils/cookie";
const AGREE_PRIVACY = "AGREE_PRIVACY";
export default {
  components: {
    BaseHeader,
    BaseNav,
    PrivacyModal
  },

  data () {
    return {
      transitionName: '',
      isShowPrivacy:false
    }
  },
  async mounted () {
    await this.checkPrivacyPolicy()
    console.log('test mounted')
    const accessToken=this.getQueryString('accessToken')
    if(accessToken){
      showLoading('登录中...')
      const  { errCode, errMsg, data, returnUrl } =await api.pcLogin({Token:accessToken})
      hideLoading()
      if (errCode === 0) {
        setCookie('token', data.accessToken)
        this.$store.commit('store', {
          token: data.accessToken,
          userName: getUserName(data)
        })
        this.$router.replace('/bind_ticket')
      } else if (errCode === 5 && errMsg === '用户未找到' && returnUrl) {
        location.href = returnUrl
      } else {
        showAlert(errMsg || '登录失败，请稍后重试')
      }
    }
  },
  watch: {
    '$route' (to, from) {
      let className = 'slide-left'
      if (this.$store.state.depthHistory.indexOf(to.path) > -1 || to.path === '/Rccl.Pcp/Home/Index') {
        className = 'slide-right'
        this.$store.commit('updateDepthHistory', to.path)
      } else {
        this.$store.commit('updateDepthHistory', from.path)
      }
      if (from.meta.index === undefined && to.meta.index === 1) {
        className = ''
      }
      this.transitionName = className
      this.bookingTracking()
      this.checkPrivacyPolicy()
    },
    shipCode () {
      this.bookingTracking()
    }
  },

  methods: {
     getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    handleClickIndex () {
      this.$refs.baseHeader.menuOpen = false
    },
    bookingTracking () {
      if (this.shipCode && this.shipCode.length > 0 && this.sailDate && this.sailDate.length > 0) {
        gioTracking('track','evt_bindingOrder', {'ShipCode': this.shipCode,'SailDate': this.sailDate})
      }
    },
    // 初始化是否同意过最新隐私政策
    async checkPrivacyPolicy() {
      const userName = this.$store.state.token;
      // let isAgreePrivacy = window.sessionStorage.getItem(AGREE_PRIVACY);
      // 用户已经登录进行验证
      if(userName || userName.length > 0) {
        // 已经同意最新隐私政策
        // data 是否同意最新版本
        //true是已经同意,false是没同意
        const { success, data:isAgree, errMsg } = await api.getUserVersionIsEffective(userName);
        if(success) {
          window.sessionStorage.setItem(AGREE_PRIVACY, isAgree ? "true" : "false");
           this.isShowPrivacy=!isAgree
        } else {
          console.log(errMsg)
          Dialog.alert({
            message: errMsg
          })
        }
      } else {
        this.isShowPrivacy = false;
      }
    },
    async submitAgreePrivacyPolicy(isAgree) {
      const userName = this.$store.state.token;
      if(isAgree) {
        const { success, errMsg } = await api.agreePrivacyPolicy(userName);
        console.log(success)
        if(success) {
          window.sessionStorage.setItem(AGREE_PRIVACY, "true");
          this.isShowPrivacy = false;
        } else {
          console.log(errMsg)
          Dialog.alert({
            message: errMsg
          })
        }
      } else {
        this.logout();
      }
    },
    logout(){
      window.sessionStorage.setItem(AGREE_PRIVACY, "null");
      this.$store.commit('logout')
      console.log('you have logout')
      location.reload();

    }

  },
  computed: {
    shipCode () {
      const bindTicket = this.$store.state.bindTicket;
      if (!bindTicket) {
        return 'nil'
      }
      return bindTicket.shipCode || 'nil'
    },
    sailDate () {
      const bindTicket = this.$store.state.bindTicket;
      if (!bindTicket || !bindTicket.sailDate || bindTicket.sailDate.length < 10) {
        return 'nil'
      }
      let sailDate = bindTicket.sailDate
      if (sailDate.length > 10) {
        sailDate = sailDate.substring(0, 10)
      }
      return sailDate
    }
  }
}
</script>

<style lang="less">
#app {
  padding-top: 122px;
  padding-bottom: 110px;
}
.slide-right-enter, .slide-left-leave-to {
  opacity: 0;
  transform: translateX(-10%);
}
.slide-right-leave-to, .slide-left-enter {
  opacity: 0;
  transform: translateX(10%);
}
.slide-right-enter-active, .slide-right-leave-active,
.slide-left-enter-active, .slide-left-leave-active {
  transition: opacity 0.15s ease-out, transform 0.15s ease-out;
}
</style>
